<div class="overflow-y-auto">

    <div class="text-primary text-2xl md:text-4xl font-extrabold">
        Data Usage
    </div>
    
    <hr class="my-4">

    <div class="flex flex-row w-full items-center border rounded-2xl border-primary my-4 md:justify-center md:w-1/3">
        <div *ngIf="showBundleBtn" class="w-full text-center p-2 rounded-xl hover:cursor-pointer" (click)="viewType('bundle')" [ngClass]="view == 'bundle' ? 'active-tab' : 'non-active'">Bundle</div>
        <div class="w-full text-center p-2 rounded-xl hover:cursor-pointer" (click)="viewType('chart')" [ngClass]="view == 'chart' ? 'active-tab' : 'non-active'">Chart</div>
    </div>
    
    <div *ngIf="bundleUsage.length && view === 'bundle'" class="flex flex-col md:flex-row md:justify-between md:items-center">
        <div *ngFor="let bundle of bundleUsage" class="flex w-full ">
            <div class="pb-4 w-full">
                <div class="flex flex-col pb-2 font-bold">
                    <h1 class="text-xl">{{bundle.description}}</h1>
                    <h2 class="text-2xl text-accent">{{bundle.volume}} GB</h2>
                </div>
                <div class="flex flex-col">
                    <div><span class="font-bold">{{bundle.monthlyUsage}}</span> GB used</div>
                    <div><span class="font-bold">{{bundle.rolledOver}}</span> GB rolled over</div>
                    <div><span class="font-bold">{{bundle.remaining}}</span> GB remaining</div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="view == 'chart'" class=" flex flex-row w-full">

        <canvas baseChart
            height="300"
            width="500"
            [data]="barChartData"
            [options]="barChartOptions"
            [plugins]="barChartPlugins"
            [legend]="barChartLegend"
            [type]="'bar'">
        </canvas>


    </div>

</div>